import script from "./UpgradeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeDialog.vue?vue&type=style&index=0&id=1fadecf6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fadecf6"]])

export default __exports__